import React, {Fragment} from "react"
import {
    Button,
    Card,
    Divider,
    Form,
    Input,
    InputNumber,
    Radio,
    Row,
    Typography,
    notification,
    Select,
    Space
} from "antd";
import {EuroOutlined, CloseCircleOutlined} from "@ant-design/icons"
import {getDeviseSymbol} from "../../i18n";

import {t} from "@lingui/core/macro"
import logger from "../../services/logger"

const {Text} = Typography

export default class Service extends React.Component {

    componentDidMount() {
        const {config} = this.props

        if (config.service.nom == undefined || config.service.prenom == undefined) {
            var service = {...config.service}
            service.nom = ""
            service.prenom = ""
            this.props.setService(service)
            return null
        }
    }

    onChangeMain(type, value) {
        if (this.props.disabled) return
        const {config} = this.props
        var service = {...config.service}
        service[type] = value
        this.props.setService(service)
    }

    onChangeOther(index, type, value) {
        if (this.props.disabled) return
        const {config} = this.props
        var service = {...config.service}
        service.other[index][type] = value
        this.props.setService(service)
    }

    addOther() {
        if (this.props.disabled) return
        const {config} = this.props
        var service = {...config.service}

        if (!service.other) {
            service.other = []
        }

        service.other.push({nom: "", prenom: ""})
        this.props.setService(service)
    }

    removeOther(index) {
        if (this.props.disabled) return
        const {config} = this.props
        var service = {...config.service}

        if (!service.other) {
            service.other = []
        }

        service.other.splice(index, 1)
        this.props.setService(service)
    }

    render() {
        const {config, context, devise} = this.props
        const service = config.service

        if (service.nom == undefined || service.prenom == undefined) {
            logger.debug({ service }, "NO NAME")
            return null
        }

        const other = service.other || []

        var data = [
            {nom: service.nom, prenom: service.prenom},
            ...other
        ]

        return (
            <div style={{padding: "10px 5%"}}>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 30,
                    padding: "0 20px"
                }}>
                    <Text strong>{service?.groupe?.name}</Text>
                    <Text strong>{service.name}</Text>
                    <Text style={{color: "grey", textAlign: "center", marginTop: 5}}>{service.description}</Text>
                </div>

                {service.sysQuantity && (
                    <div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                            <Space style={{marginBottom: 10, cursor: "pointer"}}>
                                <Button type="primary" onClick={() => this.addOther()}>{t`Ajouter`}</Button>
                                {other.length > 0 && (
                                    <Button danger onClick={() => this.removeOther(other.length - 1)}>{t`Retirer`}</Button>
                                )}
                            </Space>

                            <Text style={{color: "#000"}}>{t`Quantité`} : {data.length}</Text>
                        </div>
                    </div>
                )}

                {!service.sysQuantity && (
                    <div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                            <Button type="link" disabled={this.props.disabled} onClick={() => this.addOther()} style={{marginBottom: 10, padding: 0}}>{t`Ajouter`}</Button>

                            <Text style={{color: "#000"}}>{t`Total`} : {data.length}</Text>
                        </div>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            gap: 10
                        }}>
                            {data.map((item, index) => {
                                if (index == 0) {
                                    return (
                                        <Card key={index} style={{
                                            display: "flex",
                                            flex: "1 0 auto",
                                            width: "100%",
                                            borderWidth: 0.5,
                                            borderColor: "grey",
                                            borderRadius: 10,
                                            padding: "0 0"
                                        }}>

                                            <Text style={{
                                                display: "block",
                                                width: "100%",
                                                fontWeight: "600",
                                                color: "#000",
                                                fontSize: 15,
                                                textAlign: "center",
                                                marginBottom: 10
                                            }}>{t`1er :`}</Text>

                                            <div style={{
                                                display: "flex",
                                                width: "100%",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <div style={{width: "45%"}}>
                                                    <Input placeholder={t`Prénom`}
                                                           onChange={(e) => this.onChangeMain("prenom", e.target.value)}/>
                                                </div>

                                                <div style={{width: "45%"}}>
                                                    <Input placeholder={t`Nom`}
                                                           onChange={(e) => this.onChangeMain("nom", e.target.value)}/>
                                                </div>
                                            </div>

                                        </Card>
                                    )
                                }

                                return (
                                    <Card key={index} style={{
                                        display: "flex",
                                        flex: "1 0 auto",
                                        width: "100%",
                                        borderWidth: 0.5,
                                        borderColor: "grey",
                                        borderRadius: 10,
                                        paddingVertical: 5,
                                        paddingHorizontal: 10,
                                        position: "relative"
                                    }}>

                                        <Button type="text" disabled={this.props.disabled} aria-label={t`Retirer`}
                                                onClick={() => this.removeOther(index - 1)}
                                                icon={<CloseCircleOutlined/>}
                                                style={{position: "absolute", top: 5, right: 5}}/>

                                        <Text style={{
                                            display: "block",
                                            width: "100%",
                                            fontWeight: "600",
                                            color: "#000",
                                            fontSize: 15,
                                            textAlign: "center",
                                            marginBottom: 10
                                        }}>{t`Participant ${index + 1}`}</Text>

                                        <div style={{
                                            display: "flex",
                                            width: "100%",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}>
                                            <div style={{width: "45%"}}>
                                                <Input placeholder={t`Prénom`}
                                                       onChange={(e) => this.onChangeOther(index - 1, "prenom", e.target.value)}/>
                                            </div>

                                            <div style={{width: "45%"}}>
                                                <Input placeholder={t`Nom`}
                                                       onChange={(e) => this.onChangeOther(index - 1, "nom", e.target.value)}/>
                                            </div>
                                        </div>

                                    </Card>
                                )
                            })}
                        </div>
                    </div>
                )}

                <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20}}>
                    <Form.Item
                        label={t`Montant`}
                        name="montant"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <InputNumber size="large" min={1} placeholder={t`Montant`}
                                     addonAfter={getDeviseSymbol(context, devise)} readOnly/>
                    </Form.Item>
                </div>

                {service.recurrent && (
                    <Form.Item shouldUpdate>
                        {(e) => {
                            const value = e.getFieldValue("nbMonth")
                            const montant = e.getFieldValue("montant")
                            return (
                                <Fragment>
                                    <select className={"form-control"}
                                            disabled={this.props.disabled || (service.nbMonth !== null && service.nbMonth !== undefined)}
                                            value={value} onChange={(v) => e.setFieldValue("nbMonth", v.target.value)}>
                                        <option value={0}>{t`En continue - résiliable à tout moment`}</option>
                                        {Array.from(Array(35).keys()).map((i) => {
                                            const val = i + 2
                                            return <option value={val}>{t`pendant ${val} mois`}</option>
                                        })}
                                    </select>

                                    {value > 0 && (
                                        <div style={{marginTop: 15, textAlign: "center"}}>
                                            <Text>{t`Soit un total de ${parseFloat(montant * value).toFixed(2)}€`}</Text>
                                        </div>
                                    )}
                                </Fragment>
                            )
                        }}
                    </Form.Item>
                )}
            </div>
        )
    }
}
